import React, { useState, useEffect } from 'react';
import { dashboardService } from '../../services/dashboardService';
import { UsersIcon } from '@heroicons/react/24/outline';

interface TeamMemberCount {
  teamName: string;
  memberCount: number;
  isActive: boolean;
}

interface TeamStatistics {
  totalTeams: number;
  activeTeams: number;
  teamsCreatedToday: number;
  teamsCreatedThisWeek: number;
  teamsCreatedThisMonth: number;
  teamsByMemberCount: TeamMemberCount[];
}

export const ProcessingStatus: React.FC = () => {
  const [teamStats, setTeamStats] = useState<TeamStatistics | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  // Cores aleatórias para as equipes
  const teamColors = [
    'bg-blue-500',
    'bg-green-500',
    'bg-purple-500',
    'bg-orange-500',
    'bg-pink-500',
    'bg-indigo-500',
    'bg-red-500',
    'bg-yellow-500',
    'bg-teal-500',
    'bg-cyan-500'
  ];

  useEffect(() => {
    fetchTeamStats();
  }, []);

  const fetchTeamStats = async () => {
    try {
      setIsLoading(true);
      const response = await dashboardService.getTeamStatistics();
      setTeamStats(response);
      setError(null);
    } catch (err) {
      console.error('Erro ao buscar estatísticas de equipes:', err);
      setError('Não foi possível carregar as estatísticas de equipes.');
    } finally {
      setIsLoading(false);
    }
  };

  const getTeamColor = (index: number) => {
    return teamColors[index % teamColors.length];
  };

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-semibold text-gray-900">Equipes e Membros</h2>
        <button
          onClick={fetchTeamStats}
          className="px-3 py-1 text-sm bg-blue-50 text-blue-600 rounded-md hover:bg-blue-100 transition-colors"
        >
          Atualizar
        </button>
      </div>

      {isLoading ? (
        <div className="flex items-center justify-center py-8">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
        </div>
      ) : error ? (
        <div className="text-center py-8 text-gray-500">{error}</div>
      ) : teamStats && teamStats.teamsByMemberCount && teamStats.teamsByMemberCount.length > 0 ? (
        <div className="max-h-64 overflow-y-auto pr-2">
          <div className="space-y-3">
            {teamStats.teamsByMemberCount.map((team, index) => (
              <div key={index} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
                <div className="flex items-center space-x-3">
                  <div className={`w-3 h-3 rounded-full ${teamColors[index % teamColors.length]}`}></div>
                  <span className="font-medium text-gray-900">{team.teamName}</span>
                </div>
                <div className="flex items-center space-x-2">
                  <UsersIcon className="h-4 w-4 text-gray-400" />
                  <span className="text-sm text-gray-600">{team.memberCount}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div className="text-center py-8 text-gray-500">Nenhuma equipe encontrada</div>
      )}
    </div>
  );
}; 